import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "Tti" */ './lazyIndex'),
    {
        name: 'Tti',
    }
);
export const lazyGovern: LazyAction<typeof lazyIndex.govern, typeof lazyModule> = new LazyAction(
    lazyModule,
    m => m.govern
);
export const lazyEnableGovernReport: LazyAction<
    typeof lazyIndex.enableGovernReport,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.enableGovernReport);

/* eslint-disable-next-line owa-custom-rules/forbid-package-reexport  -- (https://aka.ms/OWALintWiki)
 * Re exporting a type from the index won't hurt bundling
 *	> Do not re-export from a separate package */
export { GovernPriority } from 'owa-client-types/lib/GovernPriority';
export { getWithinGovernor } from './getWithinGovernor';
